import { createGlobalStyle } from "styled-components"
import {
  headerHeight,
  headerHeightMd,
  headerHeightLg,
  breakpointSmall,
  linkAccent,
  fontPrimary,
  textColorDark,
  breakpointXL,
} from "../../variables"

export const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: "Brandon Printed";
  src: url('/font.woff2') format("woff2"),
       url('/font.woff') format("woff");
}

html {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

body {
  margin: ${headerHeight} 0 0 0;
  padding: 0;
  font-family:  ${fontPrimary};
}

h1,
h2{
  font-family: "Brandon Printed", sans-serif;
}

h1,
h2,
h3,
h4,
h4{
  color: ${textColorDark};
}

p{
font-size: 17px;
}

@media(min-width: ${breakpointSmall}){
  body{
    margin: ${headerHeightMd} 0 0 0;
  }
}

@media(min-width: ${breakpointXL}){
  body{
    margin: ${headerHeightLg} 0 0 0;
  }
}

strong{
  color: ${linkAccent};

  a{
    color: ${linkAccent};
  }
}

a{
  text-decoration: none;
  color: ${textColorDark};
}


.visually-hidden{
  clip: rect(0 0 0 0); 
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap; 
  width: 1px;
}
`
